document.querySelectorAll<HTMLElement>('.project-showcase').forEach((showcase) => {
    const entries = Array.from(showcase.querySelectorAll<HTMLElement>('.project-showcase__entry'));
    if (entries.length === 0) return;

    let current = 0;

    function showEntry(idx: number): void {
        const newIdx = (idx + entries.length) % entries.length;
        const animClass = newIdx > current
            ? 'project-showcase__entry--slide-in-right'
            : 'project-showcase__entry--slide-in-left';

        entries[current].classList.add('project-showcase__entry--hidden');
        current = newIdx;

        const entry = entries[current];
        entry.classList.remove('project-showcase__entry--hidden');
        entry.classList.add(animClass);
        entry.addEventListener('animationend', () => entry.classList.remove(animClass), { once: true });

        updateNavButtons();
    }

    function updateNavButtons(): void {
        entries.forEach((entry, i) => {
            const prev = entry.querySelector<HTMLButtonElement>('.project-showcase__nav-prev');
            const next = entry.querySelector<HTMLButtonElement>('.project-showcase__nav-next');
            if (prev) prev.disabled = i === 0;
            if (next) next.disabled = i === entries.length - 1;
        });
    }

    entries.forEach((entry, i) => {
        const prev = entry.querySelector<HTMLButtonElement>('.project-showcase__nav-prev');
        const next = entry.querySelector<HTMLButtonElement>('.project-showcase__nav-next');
        if (prev) prev.addEventListener('click', () => showEntry(i - 1));
        if (next) next.addEventListener('click', () => showEntry(i + 1));

        const mainImg = entry.querySelector<HTMLImageElement>('.project-showcase__main-img img');
        entry.querySelectorAll<HTMLElement>('.project-showcase__thumb').forEach((thumb) => {
            thumb.addEventListener('click', () => {
                const fullSrc = thumb.dataset.fullSrc ?? '';
                if (mainImg && fullSrc) mainImg.src = fullSrc;
                entry.querySelectorAll('.project-showcase__thumb').forEach((t) =>
                    t.classList.remove('project-showcase__thumb--active'));
                thumb.classList.add('project-showcase__thumb--active');
            });
        });
    });

    updateNavButtons();
});

// Lightbox integration — handled in WorksampleLightbox.ts via .js-showcase-gallery
